import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const ZocdocSVG = styled(Icon).attrs({ viewBox: '0 0 175 40' })`
    width: 4.375em;
`;

const Zocdoc = ({ color = navy, ...props }) => (
    <ZocdocSVG
        data-test="icon-zocdoc"
        {...props}
    >
        <path
            d="M42.5,32.9c-3.5,0-6.3-2.9-6.3-6.6c0-3.7,2.8-6.6,6.3-6.6c3.5,0,6.4,3,6.4,6.6C48.9,30,46,32.9,42.5,32.9 M42.5,12.6c-7.5,0-13.6,6.1-13.6,13.7C28.9,33.9,35,40,42.5,40c7.5,0,13.6-6.1,13.6-13.7C56.1,18.8,50,12.6,42.5,12.6"
            fill={color}
        />
        <path
            d="M101.7,33.1c-3.9,0-6.8-2.9-6.8-6.8c0-3.9,2.9-6.8,6.8-6.8c3.7,0,6.5,2.9,6.5,6.8C108.1,30.1,105.3,33.1,101.7,33.1 M107.9,15.5c-1.9-1.8-4.6-2.8-7.6-2.8c-6.4,0-12.8,4.7-12.8,13.7c0,5.3,2.3,8.5,4.2,10.3c2.3,2.1,5.5,3.4,8.4,3.4c3,0,5.8-1.1,7.7-3.2v2.6h7.4V0h-7.4V15.5z"
            fill={color}
        />
        <path
            d="M132.8,32.9c-3.5,0-6.3-2.9-6.3-6.6c0-3.7,2.8-6.6,6.3-6.6c3.5,0,6.4,3,6.4,6.6C139.2,30,136.3,32.9,132.8,32.9 M132.8,12.6c-7.5,0-13.6,6.1-13.6,13.7c0,7.5,6.1,13.7,13.6,13.7c7.5,0,13.6-6.1,13.6-13.7C146.4,18.8,140.3,12.6,132.8,12.6"
            fill={color}
        />
        <path
            d="M72.9,32.9c-3.6,0-6.5-2.9-6.5-6.6c0-3.7,2.9-6.6,6.5-6.6c2.3,0,4.4,1.2,5.5,3.2l6.1-3.8c-2.4-4-6.8-6.5-11.7-6.5c-7.5,0-13.6,6.1-13.6,13.7c0,7.5,6.1,13.7,13.6,13.7c5,0,9.3-2.4,11.7-6.5l-6.1-3.8C77.3,31.7,75.2,32.9,72.9,32.9"
            fill={color}
        />
        <path
            d="M163.2,32.9c-3.6,0-6.5-2.9-6.5-6.6c0-3.7,2.9-6.6,6.5-6.6c2.3,0,4.4,1.2,5.5,3.2l6.1-3.8c-2.4-4-6.8-6.5-11.7-6.5c-7.5,0-13.6,6.1-13.6,13.7c0,7.5,6.1,13.7,13.6,13.7c5,0,9.3-2.4,11.7-6.5l-6.1-3.8C167.6,31.7,165.5,32.9,163.2,32.9"
            fill={color}
        />
        <path
            d="M23.9,11.1l2.3-3.3c0,0,0.1-0.2,0.1-0.2c0.2-0.3,0.3-0.6,0.3-0.9c0,0,0-0.1,0-0.1V6.4V0H0.1l0,7.3h17.5l-1.9,2.6L4.7,25.8l-4.1,5.9c0,0-0.1,0.2-0.1,0.2c-0.2,0.3-0.3,0.6-0.3,0.9c0,0,0,0.1,0,0.1v0.3v6.4h26.4l0-7.3H9l3.4-4.8L23.9,11.1z"
            fill={color}
        />
    </ZocdocSVG>
);

export {
    Zocdoc as default,
    Zocdoc,
};
